import { initialState } from "./state"

export default {
  setOptionsFilterAdditionalServices: (state, payload) =>
    (state.optionsFilterAdditionalServices = payload),
  setListAdditionalServices: (state, payload) =>
    (state.listAdditionalServices = payload),
  setPaginationListAdditionalServices: (state, payload) =>
    (state.paginationListAdditionalServices = payload),
  setModalConfirmNoAdditionalServices: (state, payload) =>
    (state.modalConfirmNoAdditionalServices = payload),
  setModalConfirmMaxItens: (state, payload) =>
    (state.modalConfirmMaxItens = payload),

  setFilterName: (state, payload) => (state.filterName = payload),

  resetAdditionalServices: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
